var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoAnswer = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 4,
  viewBox: "0 0 16 4",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.5,2c0-.82786.67214-1.5,1.5-1.5h12c.8295,0,1.5.67182,1.5,1.5c0,.82986-.6701,1.5-1.5,1.5h-12c-.82818,0-1.5-.67047-1.5-1.5Z",
  transform: "matrix(1.066667 0 0 1.333333-.533336-.666666)",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoAnswer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-answer.2f067ca829adf37004ca717ddb33e445.svg";